module.exports = __webpack_public_path__ + "static/media/p208d2.ebdfb6ae.jpg";